/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */
import VueJsTour from '@globalhive/vuejs-tour'

// Plugins
import { loadFonts } from './webfontloader'
import vuetify from './vuetify'
import apollo from './apollo'
import router from '../router'
import store from '../store'
import gtm from './gtm'

// Types
import type { App } from 'vue'

export function registerPlugins (app: App) {
  loadFonts()
  app
    .use(vuetify)
    .use(apollo)
    .use(router)
    .use(store)
    .use(VueJsTour)
  // GTM_IDが設定されているときだけ読み込む
  if (import.meta.env.VITE_GTM_ID) {
    app.use(gtm)
  }
}
